import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StaffNavbar from '../components/StaffNavbar';
import BackButton from '../components/BackButton';
import apiService from '../services/api';
import '../styles/StaffPages.css';

const SuperuserManageLinks = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);
  const [form, setForm] = useState({
    referral_app_url: '',
  });
  const navigate = useNavigate();

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  useEffect(() => {
    const load = async () => {
      try {
        const currentUser = await apiService.fetchCurrentUser();
        if (!currentUser?.is_superuser) {
          navigate('/staff/dashboard/');
          return;
        }

        const resp = await apiService.getManagedLinksSuperuser();
        const links = resp?.links || {};
        setForm({
          referral_app_url: links.referral_app_url || '',
        });
      } catch (error) {
        console.error('Failed to load managed links:', error);
        showToast('Failed to load links', 'error');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [navigate]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const resp = await apiService.updateManagedLinksSuperuser({
        referral_app_url: form.referral_app_url,
      });
      const links = resp?.links || {};
      setForm({
        referral_app_url: links.referral_app_url || '',
      });
      showToast('Links updated');
    } catch (error) {
      const msg =
        error?.response?.data?.referral_app_url?.[0] ||
        error?.response?.data?.error ||
        'Failed to update links';
      showToast(msg, 'error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-dashboard">
        <StaffNavbar activeSection="superuser" />
        <div className="admin-main">
          <div className="admin-content">
            <div
              style={{
                textAlign: 'center',
                padding: '3rem',
                color: '#666',
              }}
            >
              Loading...
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <StaffNavbar activeSection="superuser" />
      <div className="admin-main">
        <div className="admin-content">
          <BackButton text="Back to Superuser Dashboard" to="/superuser/dashboard/" />
          <h1 className="staff-page-header">Manage Links</h1>
          <p className="staff-page-subheader">Update URLs used across the apps</p>

          {toast && (
            <div className={`toast toast-${toast.type || 'success'}`}>{toast.message}</div>
          )}

          <div style={{ marginTop: '24px', maxWidth: '720px' }}>
            <div className="form-group">
              <label className="form-label">Referral app URL (for sharing referral messages)</label>
              <input
                className="form-input"
                type="url"
                value={form.referral_app_url}
                onChange={e => setForm(prev => ({ ...prev, referral_app_url: e.target.value }))}
                placeholder="https://..."
              />
            </div>

            <div style={{ marginTop: '16px' }}>
              <button className="primary-button" onClick={handleSave} disabled={saving}>
                {saving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperuserManageLinks;

